<template>
  <div :class="$style.contentBlocksList">
    <template v-for="(textBlock, index) of data">
      <record-main-image
        v-if="textBlock.type === 'images' && isMainPhoto(textBlock, index)"
        :key="textBlock.type + index"
        :mainImageInfo="getImageData(textBlock.value, isTablet, isMobile)"
        :mainImageData="mainImageData"
        :share-link="createImageShareLink(textBlock.value.id)"
        :author-label="getImageAuthorLabelByType(textBlock.media['image-type'])"
        :idAdvVOX="idAdvVOX"
        :index="index"
        @shareClicked="
          sendShareRGForImage(
            'Изображение',
            textBlock.value.position,
            textBlock.value.id,
            $event
          )
        "
        @imageClicked="openImageViewer($event, textBlock.value.position)"
        @onImageVisible="
          sendViewRGForImage(
            textBlock.value.position,
            'Изображение',
            `Увидел Фото №${textBlock.value.position}`,
            'viewFancyBox'
          )
        "
      />

      <record-image
        v-if="textBlock.type === 'images' && !isMainPhoto(textBlock, index)"
        :class="$style.mediaBlock"
        :key="textBlock.type + index"
        :data="textBlock.value"
        :advBlock="getAdvInImage(textBlock)"
        :idAdvVOX="idAdvVOX"
        :index="index"
        :allowInImageAdv="checkAllowInImageAdv(textBlock.value.position)"
        :media-class="textBlock.media.class"
        :is-post="isPost"
        :author-label="getImageAuthorLabelByType(textBlock.media['image-type'])"
        :share-link="createImageShareLink(textBlock.value.id)"
        :need-check-figure-size="needCheckFigureSize"
        @shareClicked="
          sendShareRGForImage(
            textBlock.media.class === 'center-vertical' ? 'Инфографика' : 'Изображение',
            textBlock.value.position,
            textBlock.value.id,
            $event
          )
        "
        @imageClicked="openImageViewer($event, textBlock.value.position)"
        @onImageVisible="
          sendViewRGForImage(
            textBlock.value.position,
            textBlock.media.class === 'center-vertical' ? 'Инфографика' : 'Изображение',
            `Увидел Фото №${textBlock.value.position}`,
            'viewFancyBox'
          )
        "
      />
      <record-theme-subscriptions
        v-if="textBlock.type === 'themeSubscription'"
        :class="$style.insertBlock"
        :key="textBlock.type + index"
        :title="textBlock.value.title"
        :telegramLink="textBlock.value.telegram"
        :subscriptionTypeId="textBlock.media.subscriptionTypeId"
        :isMobile="isMobile"
        caption="новость из сюжета"
        note="Подпишись на публикации этого сюжета"
        @visible="sendRGForSubscriptions('Просмотр', 'SubscriptionInsertView')"
        @showFormBtnClicked="
          sendRGForSubscriptions('Клик', 'SubscriptionInsertClickEmail', 'Email')
        "
        @closeFormBtnClicked="
          sendRGForSubscriptions('Отменил заполнение', 'SubscriptionInsertAborted')
        "
        @subscribeTgBtnClicked="
          sendRGForSubscriptions('Клик', 'SubscriptionInsertClickTG', 'TG')
        "
        @changedForm="
          sendRGForSubscriptions('Начал заполнять', 'SubscriptionInsertFilling')
        "
        @subscribeSuccess="
          sendRGForSubscriptions('Отправил форму', 'SubscriptionInsertEnd')
        "
      />

      <rotated-inserts
        v-if="textBlock.type === 'rotatedInserts'"
        :key="'rotatedInserts' + index"
        :class="$style.insertBlock"
        :inserts="textBlock.value.blocks"
      />

      <jtn-ui-record-text
        v-if="textBlock.type === 'text'"
        :key="textBlock.type + index"
        :text="textBlock.value.text"
        :is-post="isPost"
      />

      <jtn-ui-record-text
        v-if="textBlock.type === 'append'"
        :key="textBlock.type + index"
        :text="textBlock.media.content"
      />

      <record-foreign-agent
        v-if="textBlock.type === 'foreignAgent'"
        :key="textBlock.type + index"
        :text="textBlock.media.content"
      />

      <record-spoiler
        v-if="textBlock.type === 'spoiler'"
        :key="textBlock.type + index"
        :class="$style.mediaBlock"
        :data="textBlock.value"
      />

      <no-ssr v-if="textBlock.type === 'imagesPoll'" :key="textBlock.type + index">
        <record-images-poll
          :class="$style.mediaBlock"
          :poll="textBlock.value"
          :isUserAuth="isUserAuth"
          :isNofollow="isNofollow"
          @imageClicked="openImageViewer($event)"
          @viewTest="sendViewRGForTest"
          @linkClicked="sendVotesRGForTest"
          @answerChosen="sendVotesRGForTest"
          @clickRegister="showRegisterModal"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'gif'" :key="textBlock.type + index">
        <record-gif
          :class="$style.mediaBlock"
          :data="textBlock.value"
          :is-post="isPost"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'videos'" :key="textBlock.type + index">
        <record-video
          :class="$style.mediaBlock"
          :video="textBlock.value"
          :is-post="isPost"
          @videoPlayerEvent="sendVideoReachGoal($event)"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'audios'" :key="textBlock.type + index">
        <record-audio
          :class="$style.mediaBlock"
          :data="textBlock.value"
          :audio-id="Number(textBlock.media.position)"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'customWidget'" :key="textBlock.type + index">
        <custom-widget :class="$style.mediaBlock" :data="textBlock" />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'iframe'" :key="textBlock.type + index">
        <custom-iframe
          :class="$style.mediaBlock"
          :media="textBlock.media"
          :is-post="isPost"
          :need-check-figure-size="needCheckFigureSize"
          @viqeoPlayerEvent="sendYoutubeViewedRG($event)"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'doublePhoto'" :key="textBlock.type + index">
        <record-double-photo
          :class="$style.mediaBlock"
          :data="textBlock.value"
          :media="textBlock.media"
          :author-right-label="
            getImageAuthorLabelByType(textBlock.media['right-image-type'])
          "
          :author-left-label="
            getImageAuthorLabelByType(textBlock.media['left-image-type'])
          "
          :is-post="isPost"
          :need-check-figure-size="needCheckFigureSize"
          :share-link="createImageShareLink(textBlock.value.left.id)"
          @shareClicked="
            sendShareRGForImage(
              'Шторки',
              textBlock.value.position,
              textBlock.value.left.id,
              $event
            )
          "
          @onVisible="
            sendViewRGForImage(
              textBlock.value.position,
              'Шторки',
              `Увидел Шторки №${textBlock.value.position}`,
              'viewFancyBox'
            )
          "
          @slideEnd="
            sendPhotosReachGoal(
              `Шторки №${textBlock.value.position} двигал`,
              'navChangeBox'
            )
          "
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'feedback'" :key="textBlock.type + index">
        <record-feedback
          :class="$style.mediaBlock"
          :feedback-data="textBlock.value"
          :record-id="recordId"
          @visible="sendFeedbackReachGoal('view')"
          @phoneNumberClicked="sendFeedbackReachGoal('clickPhone')"
          @openedFeedbackToEditorsForm="sendFeedbackReachGoal('openForm')"
          @openedSocialNetwork="sendFeedbackSocialReachGoal($event)"
          @sent="sendFeedbackReachGoal('sent')"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'poll'" :key="textBlock.type + index">
        <record-poll
          :class="$style.mediaBlock"
          :options="textBlock.media"
          :data="textBlock.value"
          :record-id="recordId"
          :is-scroll-on-mounted="isScrollToPoll && index === firstPollIndex"
          @answerChosen="sendVotesRGForTest"
          @viewTest="sendViewRGForTest"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'test'" :key="textBlock.type + index">
        <test-with-result
          :class="$style.mediaBlock"
          :data="textBlock.value"
          :test-id="textBlock.media.poll"
          :record-id="recordId"
          @viewTest="sendViewRGForTest"
          @answerChosen="sendTestWithResultReachGoal(textBlock.media.poll)"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'testResult'" :key="textBlock.type + index">
        <test-result
          :class="$style.mediaBlock"
          :data="textBlock.media"
          :image="textBlock.value"
          @viewTestResult="sendViewRGForTestResult"
          @repeatTest="sendClickRGForTest(`Пройти еще раз`)"
          @shareTest="sendClickRGForTest(`Поделиться ${$event}`)"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'yesnotest'" :key="textBlock.type + index">
        <test-yes-no
          :class="$style.mediaBlock"
          :data="textBlock.value"
          :test-id="textBlock.media.poll"
          @shared="shareTest($event)"
          @repeatTest="sendClickRGForTest(`Пройти еще раз`)"
          @answerChosen="sendVotesRGForTest"
          @viewTestResult="sendViewRGForTestResult"
          @viewTest="sendViewRGForTest"
        />
      </no-ssr>

      <record-viqeo
        v-if="textBlock.type === 'viqeoVideo'"
        :key="textBlock.type + index"
        :class="$style.mediaBlock"
        :viqeo="textBlock.value"
        :is-post="isPost"
        @viqeoPlayerEvent="sendVideoReachGoal($event)"
      />

      <no-ssr v-if="textBlock.type === 'gallery'" :key="textBlock.type + index">
        <record-gallery
          :class="$style.mediaBlock"
          :data="textBlock.value"
          :is-post="isPost"
          :gallery-type="textBlock.media.class"
          :is-mobile="isMobile"
          :recordId="recordId"
          @shareClicked="
            sendShareRGForImage(
              'Галерея',
              textBlock.value.position,
              $event.imageId,
              $event.socialType
            )
          "
          @galleryVisible="
            sendViewRGForImage(
              textBlock.value.position,
              'Галерея',
              `Увидел Галерея №${textBlock.value.position}`,
              'viewFancyBox'
            )
          "
          @nextClicked="
            clickGallery(
              textBlock.value.position,
              'Вправо',
              `Галерея №${textBlock.value.position} вправо`,
              'navGalleryBox'
            )
          "
          @previousClicked="
            clickGallery(
              textBlock.value.position,
              'Влево',
              `Галерея №${textBlock.value.position} влево`,
              'navGalleryBox'
            )
          "
          @previewClicked="
            clickGallery(
              textBlock.value.position,
              'Превью',
              `Галерея №${textBlock.value.position} превью`,
              'navGalleryBox'
            )
          "
          @swipeRight="
            clickGallery(
              textBlock.value.position,

              'Вправо',
              `Галерея №${textBlock.value.position} вправо`,
              'navGalleryBox'
            )
          "
          @swipeLeft="
            clickGallery(
              textBlock.value.position,

              'Влево',
              `Галерея №${textBlock.value.position} влево`,
              'navGalleryBox'
            )
          "
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'logotype'" :key="textBlock.type + index">
        <address-block
          :data="textBlock.value"
          :settings="textBlock.media"
          :is-bordered="hasBottomBorder(index, textBlock.type)"
        />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'wquote'" :key="textBlock.type + index">
        <record-quote :class="$style.mediaBlock" :data="textBlock.media" />
      </no-ssr>

      <no-ssr v-if="textBlock.type === 'documents'" :key="textBlock.type + index">
        <record-file :data="textBlock.value" />
      </no-ssr>

      <AdvCreative
        v-if="isDisplayAdv(textBlock.type) && !checkInfiniteInread(textBlock.type)"
        :key="textBlock.type + index"
        :adv="getInreadAdvBlock(textBlock.type)"
      />

      <template v-if="isDisplayAdv(textBlock.type) && checkInfiniteInread(textBlock.type)">
        <no-ssr :key="index">
          <AdvCreative
            :key="textBlock.type + index"
            :adv="getInreadAdvBlock(textBlock.type)"
            :index="index"
            :clientRender="true"
          />
        </no-ssr>
      </template>

      <auth-and-register-modal v-if="isAuthModalRendered" v-model="isAuthModalOpen" />
    </template>
  </div>
</template>

<script>
import { guardEmptyString, guardUnspecified } from '@smh/utils/guards';
import NoSSR from 'vue-no-ssr';
import { useModule } from 'vuex-simple';
import { JtnUiRecordText } from '@jtn-ui/components/record';
import { JtnUiTypography } from '@jtnews/jtn-ui';
import { convertToCamelCase, StoreMixin, getImageData } from '@jtnews/shared';
import { LazyBlock } from '@jtnews/shared/ui';
import { RECORD_MODULE_NAMESPACE } from '../../store';
import { AdvInread, AdvCreative } from '../../../../shared/components/_adv';

import AuthorOpinion from '../../components/author-opinion/index';
import RecordMainImage from '../../components/record-main-image/index';
import RecordImage from '../../components/record-image/index';
import { RecordThemeSubscriptions } from '../../components/record-theme-subscriptions/index';

import { Regions } from '@smh/projects/regions';

const RecordImagesPoll = () =>
  import(
    /* webpackChunkName: "record-images-poll" */ '../../components/record-images-poll'
  ).then(m => m.RecordImagesPoll);

const RecordFeedback = () =>
  import(
    /* webpackChunkName: "record-feedback" */ '../../components/record-feedback'
  ).then(m => m.RecordFeedback);

const TestWithResult = () =>
  import(
    /* webpackChunkName: "test-with-result" */ '../../components/test-with-result'
  ).then(m => m.TestWithResult);

const TestResult = () =>
  import(/* webpackChunkName: "test-result" */ '../../components/test-with-result').then(
    m => m.TestResult
  );

const RecordViqeo = () =>
  import(/* webpackChunkName: "record-viqeo" */ '../../components/record-viqeo').then(
    m => m.RecordViqeo
  );

const RotatedInserts = () =>
  import(/* webpackChunkName: "rotated-inserts" */ '../rotated-inserts').then(
    m => m.RotatedInserts
  );

const TestYesNo = () =>
  import(/* webpackChunkName: "test-yes-no" */ '../../components/test-yes-no/index');

const RecordGif = () =>
  import(/* webpackChunkName: "record-gif" */ '../../components/record-gif/index');

const RecordVideo = () =>
  import(/* webpackChunkName: "record-video" */ '../../components/record-video/index');

const RecordAudio = () =>
  import(/* webpackChunkName: "record-audio" */ '../../components/record-audio/index');

const CustomWidget = () =>
  import(/* webpackChunkName: "custom-widget" */ '../../components/custom-widget/index');

const CustomIframe = () =>
  import(/* webpackChunkName: "custom-iframe" */ '../../components/custom-iframe/index');

const RecordDoublePhoto = () =>
  import(
    /* webpackChunkName: "record-double-photo" */ '../../components/record-double-photo/index'
  );

const RecordPoll = () =>
  import(/* webpackChunkName: "record-poll" */ '../../components/record-poll/index');

const RecordGallery = () =>
  import(
    /* webpackChunkName: "record-gallery" */ '../../components/record-gallery/index'
  ).then(m => m.RecordGallery);

const AddressBlock = () =>
  import(/* webpackChunkName: "address-block" */ '../../components/address-block/index');

const RecordQuote = () =>
  import(/* webpackChunkName: "record-quote" */ '../../components/record-quote/index');

const RecordFile = () =>
  import(/* webpackChunkName: "record-file" */ '../../components/record-file/index').then(
    m => m.RecordFile
  );

const RecordSpoiler = () =>
  import(/* webpackChunkName: "record-spoiler" */ '../../components/record-spoiler').then(
    m => m.RecordSpoiler
  );

const AuthAndRegisterModal = () =>
  import(/* webpackChunkName: "auth-and-register-modal" */ '@jtnews/layout/modals').then(
    m => m.AuthAndRegisterModal
  );

const RecordForeignAgent = () =>
  import(
    /* webpackChunkName: "record-foreign-agent" */ '../../components/record-foreign-agent'
  ).then(m => m.RecordForeignAgent);

const VOX_SCRIPT_SRC = 'https://st.hbrd.io/ssp.js';

const VOX_ADV_IDS = {
  [Regions.Arkhangelsk]: '616560a37bc72f91a887cf10',
  [Regions.Chelyabinsk]: '61655e517bc72f91a887cf04',
  [Regions.Chita]: '62fa04054d506e7bec6c0b92',
  [Regions.Irkutsk]: '62fa042b4d506e7bec6c0b93',
  [Regions.Kazan]: '62fa00924d506e7bec6c0b83',
  [Regions.KhantyMansiysk]: '62fa036e7bc72f4a30d2dc87',
  [Regions.KrasnodarRugion]: '62fa03e04d506e7bec6c0b91',
  [Regions.Krasnoyarsk]: '61655e7a4d506e9b8428cf55',
  [Regions.Kemerovo]: '62fa01f14d506e7bec6c0b89',
  [Regions.Kirov]: '62fa020d7bc72f4a30d2dc7b',
  [Regions.Kurgan]: '62fa02294d506e7bec6c0b8a',
  [Regions.Lipetsk]: '62fa02557bc72f4a30d2dc7e',
  [Regions.Murmansk]: '62fa02797bc72f4a30d2dc7f',
  [Regions.NizhnyNovgorod]: '61655ea67bc72f91a887cf06',
  [Regions.Nsk]: '61655dfe4d506e9b8428cf53',
  [Regions.Omsk]: '6165603f7bc72f91a887cf0f',
  [Regions.Orenburg]: '62fa02934d506e7bec6c0b8c',
  [Regions.Perm]: '61655f437bc72f91a887cf0b',
  [Regions.Pskov]: '62fa02b57bc72f4a30d2dc81',
  [Regions.Rostov]: '61655f9e4d506e9b8428cf59',
  [Regions.Ryazan]: '62fa02e97bc72f4a30d2dc83',
  [Regions.Samara]: '61655f1d7bc72f91a887cf09',
  [Regions.SaintPetersburg]: '62fa016f4d506e7bec6c0b87',
  [Regions.Saratov]: '62fa01267bc72f4a30d2dc77',
  [Regions.Stavropol]: '62fa01d47bc72f4a30d2dc79',
  [Regions.Tambov]: '62fa03187bc72f4a30d2dc85',
  [Regions.Tula]: '62fa033c4d506e7bec6c0b8e',
  [Regions.Tyumen]: '61655ed47bc72f91a887cf07',
  [Regions.Ufa]: '61655fcc4d506e9b8428cf5b',
  [Regions.Volgograd]: '61655f727bc72f91a887cf0c',
  [Regions.Yakutsk]: '62fa00f54d506e7bec6c0b85',
  [Regions.YamaloNenetsAutonomousArea]: '62fa03c67bc72f4a30d2dc89',
  [Regions.Yaroslavl]: '616560057bc72f91a887cf0d',
  [Regions.Yekaterinburg]: '61655e2c7bc72f91a887cf02',
  [Regions.Mosk]: '651144887bc72f33d0fa3187',
  [Regions.Sochi]: '6511499c4d506e0674a99753',
  [Regions.Magnitogorsk]: '65115afc7bc72f33d0fa31ed',
  [Regions.Tolyatty]: '65115ca04d506e0674a99796'
};

const INFINITE_INREADS = [
  'desktop_record_inread_advert_3',
  'mobile_record_inread_advert_6'
];

const TEST_MAP = {
  poll: 'Опрос',
  ['yes-no']: 'Да-Нет',
  test: 'Стандартный',
  result: 'Стандартный',
  image: 'Опрос с картинками'
};

const SOCIAL_MAP = {
  telegram: 'TG',
  twitter: 'TW',
  ok: 'OK',
  vk: 'VK',
  wa: 'WA',
  whatsapp: 'WA',
  link: 'link'
};

export default {
  name: 'ContentBlocksList',
  components: {
    'no-ssr': NoSSR,
    JtnUiTypography,
    AdvInread,
    AdvCreative,
    AddressBlock,
    AuthorOpinion,
    CustomIframe,
    CustomWidget,
    LazyBlock,
    RecordAudio,
    RecordDoublePhoto,
    RecordFile,
    RecordGallery,
    RecordGif,
    RecordImage,
    RecordImagesPoll,
    RecordMainImage,
    RecordPoll,
    RecordQuote,
    RecordViqeo,
    RecordSpoiler,
    RotatedInserts,
    JtnUiRecordText,
    RecordThemeSubscriptions,
    RecordVideo,
    TestResult,
    TestWithResult,
    TestYesNo,
    RecordFeedback,
    AuthAndRegisterModal,
    RecordForeignAgent
  },
  mixins: [StoreMixin],
  provide() {
    return {
      getImagesPollAnswers: this.getImagesPollAnswers,
      setImagesPollVotes: this.setImagesPollVotes,
      getPollAnswers: this.getPollAnswers,
      setPollVotes: this.setPollVotes
    };
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    isPost: {
      type: Boolean,
      default: false
    },
    needCheckFigureSize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isViqeoEventsSubscribed: false,
      inreadsAdv: [],
      isAuthModalOpen: false,
      isAuthModalRendered: false,
      authParams: null,
    };
  },
  computed: {
    recordModule() {
      return useModule(this.$store, RECORD_MODULE_NAMESPACE);
    },
    recordData() {
      return this.store.layoutModule?.record?.data ?? null;
    },
    recordId() {
      return this.recordData?.id ?? -1;
    },
    recordHeader() {
      return this.recordData?.header ?? '';
    },
    recordThemeName() {
      const [theme] = this.recordData?.themes ?? [];
      return theme?.name ?? '';
    },
    isNofollow() {
      return this.recordData?.nofollow ?? false;
    },
    regionId() {
      return this.store.regionId;
    },
    imagesPolls() {
      return this.data.filter(block => block.type === 'imagesPoll');
    },
    isUserAuth() {
      return Boolean(this.store.commonModule?.userInfo ?? false);
    },
    isMobile() {
      return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
    },
    isTablet() {
      return this.store.deviceInfo.isTablet;
    },
    utmParamsForImage() {
      return this.store.sharingModule.getUtmParams(
        'sharephotopreview',
        `${this.recordId}`,
        this.regionId
      );
    },
    isShowInImageAds() {
      return (
        !this.isHoldoutTest &&
        (this.store.layoutModule?.record?.params?.inImageAds ?? false)
      );
    },
    idAdvVOX() {
      return VOX_ADV_IDS[this.regionId] ?? '';
    },
    socialShareImage() {
      return this.recordData?.socialShare?.[0]?.image ?? '';
    },
    isHoldoutTest() {
      return this.store.layoutModule.isHoldoutTest;
    },
    mainImageData() {
      return this.recordModule?.getMainImageData.data;
    },
    isScroogeTest() {
      return this.store.layoutModule.isScroogeTest;
    },
    firstPollIndex() {
      return this.data?.findIndex(item => item.type === 'poll');
    },
    isScrollToPoll() {
      const isSharePoll = this.$route.query['sharePoll'];

      return guardUnspecified(isSharePoll) && guardEmptyString(isSharePoll);
    },
  },
  mounted() {
    this.initInImageAdvVOX();
  },
  methods: {
    getImageData,
    isMainPhoto(textBlock, index) {
      return index === 0 && !this.isPost && textBlock.media.class !== 'center-vertical';
    },
    hasBottomBorder(index, type) {
      if (this.data[index + 1]) {
        return this.data[index + 1].type !== type;
      }

      return true;
    },
    getImageAuthorLabelByType(type) {
      const typeToLabelMap = {
        photo: 'Фото',
        infographics: 'Инфографика',
        collage: 'Коллаж',
        map: 'Карта',
        scheme: 'Схема',
        screenshot: 'Скриншот',
        picture: 'Иллюстрация',
        sketch: 'Эскиз'
      };

      return typeToLabelMap[type] ?? 'Фото';
    },
    async setImagesPollVotes(pollId, answerId) {
      const params = {
        recordId: this.recordId,
        regionId: this.regionId,
        answerId,
        pollId
      };

      return await this.recordModule.setImagesPollVotes(params);
    },
    async getImagesPollAnswers(pollId) {
      const params = {
        recordId: this.recordId,
        regionId: this.regionId,
        pollId
      };

      return await this.recordModule.getImagesPollVotes(params);
    },
    async setPollVotes(pollId, answerId) {
      const params = {
        recordId: this.recordId,
        regionId: this.regionId,
        answerId,
        pollId
      };

      return await this.recordModule.setPollVotes(params);
    },
    async getPollAnswers(pollId) {
      const params = {
        recordId: this.recordId,
        regionId: this.regionId,
        pollId
      };

      return await this.recordModule.getPollVotes(params);
    },
    openImageViewer(id, position) {
      this.store.layoutModule.imageViewerService.changeState({
        id: 'ivRecord',
        isOpen: true,
        imageId: id,
        position
      });
    },
    sendViewRGForImage(position, type, value, goalName) {
      this.sendPhotosReachGoal(value, goalName);
      this.sendViewImageAnalytics(type, position);
    },
    sendViewImageAnalytics(type, position) {
      this.sendNewFormatReachGoal(
        'ViewImage',
        'Изображение',
        'Просмотр',
        `${type} ${position}`
      );
    },
    sendClickRGForTest(clickPlace) {
      this.sendNewFormatReachGoal(
        'ClickTestResult',
        'Результаты теста',
        'Клик',
        clickPlace
      );
    },
    shareTest(params) {
      this.store.sharingModule.shareTestResult(params);
      this.sendClickRGForTest(`Поделиться ${params.socialTarget}`);
    },
    sendRGForSubscriptions(value, goalName, target = '') {
      const blockType = 'Центральная колонка';
      const fieldType = 'Врезка подписки';
      const valueName = {
        [value]: {
          [this.recordId]: `${this.recordThemeName}${target !== '' ? ` (${target})` : ''}`
        }
      };
      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName
      });
      if (value === 'Клик' || value === 'Просмотр') {
        this.sendNewFormatReachGoal(
          value === 'Клик' ? 'ClickSubscription' : 'ViewSubscription',
          'Подписка',
          value,
          value === 'Клик' ? target : undefined
        );
      }
    },
    sendNewReachGoal(fieldType, value, goalName, productName) {
      const blockType = 'Центральная колонка';
      const valueName = { [value]: this.recordId };
      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName,
        productName,
        willDeprecate: true
      });
    },
    sendNewFormatReachGoal(goalName, blockType, actionType, prop1, prop2) {
      this.store.analyticsModule.sendNewFormatReachGoal({
        goalName,
        blockType,
        actionType,
        prop1,
        prop2
      });
    },
    sendVideoReachGoal({ eventType, videoId, goalName, action, playerType, duration }) {
      const blockType = 'Центральная колонка';
      const fieldType = 'ВидеоПлеер';
      const videoValue = action === 'Просмотр' ? { [videoId]: duration } : videoId;
      const value = { [this.recordId]: videoValue };
      const valueName = { [eventType]: value };

      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName,
        willDeprecate: true
      });
      if (action === 'Просмотр') {
        this.sendNewFormatReachGoal(
          'ViewArticleVideo',
          'Видео',
          'Просмотр',
          playerType,
          videoId
        );
      } else if (action !== 'Start') {
        this.sendNewFormatReachGoal('ClickArticleVideo', 'Видео', 'Клик', playerType, {
          [videoId]: action
        });
      }
    },
    sendFeedbackReachGoal(key) {
      const fieldType = 'Форма связи с редакцией в новости';
      const config = {
        view: {
          value: 'Просмотр',
          goalName: 'ViewConnactionForm'
        },
        clickPhone: {
          value: 'Клик: Телефон',
          goalName: 'ClickConnactionFormPhone'
        },
        openForm: {
          value: 'Клик: Написать',
          goalName: 'ClickConnactionFormText'
        },
        sent: {
          value: 'Отправлена',
          goalName: 'SentUserToConnactionForm'
        }
      };

      const event = config[key];
      this.sendNewReachGoal(fieldType, event.value, event.goalName);

      const configNewReachGoal = {
        view: {
          value: 'Просмотр',
          goalName: 'ViewArticleFeedBack',
          place: undefined
        },
        clickPhone: {
          value: 'Клик',
          goalName: 'ClickArticleFeedBack',
          place: 'Телефон'
        },
        openForm: {
          value: 'Клик',
          goalName: 'ClickArticleFeedBack',
          place: 'Кнопка'
        }
      };
      const reachGoal = configNewReachGoal[key];
      this.sendNewFormatReachGoal(
        reachGoal.goalName,
        fieldType,
        reachGoal.value,
        reachGoal.place
      );
    },
    sendFeedbackSocialReachGoal(socialName) {
      const socialNameMap = {
        vk: 'VK',
        instagram: 'IG',
        telegram: 'TG',
        viber: 'VB',
        wa: 'WA',
        youtube: 'YT'
      };
      const fieldType = 'Форма связи с редакцией в новости';
      const value = `Клик: ${socialNameMap[socialName]}`;
      const goalName = `ClickConnactionForm${socialNameMap[socialName]}`;

      this.sendNewReachGoal(fieldType, value, goalName);
      const social = socialNameMap[socialName];
      this.sendNewFormatReachGoal(
        'ClickArticleFeedBack',
        'Форма связи с редакцией в новости',
        'Клик',
        social
      );
    },
    sendPhotosReachGoal(value, goalName) {
      const fieldType = 'Фото на материале';
      this.sendNewReachGoal(fieldType, value, goalName);
    },
    clickGallery(position, clickType, value, goalName) {
      this.sendNewFormatReachGoal(
        'ScrollImage',
        'Изображение',
        'Скролл',
        `Галерея ${position}`,
        clickType
      );
      this.sendPhotosReachGoal(value, goalName);
    },
    sendShareRGForImage(attachName, imagePosition, imageId, socialType) {
      const social = SOCIAL_MAP[socialType];
      if (guardUnspecified(social)) {
        this.sendClickImageAnalytics(attachName, imagePosition, `поделиться ${social}`);
        let typeImage = attachName;
        if (typeImage === 'Изображение' || typeImage === 'Инфографика') {
          typeImage = 'Фото';
        }
        this.sendShareReachGoal(typeImage, imagePosition, imageId, socialType);
      }
    },
    sendClickImageAnalytics(typeImage, imagePosition, action) {
      this.sendNewFormatReachGoal(
        'ClickImage',
        'Изображение',
        'Клик',
        `${typeImage} ${imagePosition}`,
        action
      );
    },
    sendShareReachGoal(attachName, imagePosition, imageId, socialType) {
      const placeName = socialType.toUpperCase();
      const fieldType = 'Фото на материале';
      const reachGoalValue = `Шаринг ${attachName} №${imagePosition} в ${placeName}`;
      const reachGoalName = `sharePhotoBox${placeName}`;

      this.sendNewReachGoal(fieldType, reachGoalValue, reachGoalName);

      this.store.sharingModule.shareRecordImage({
        socialTarget: socialType,
        title: this.recordHeader,
        imageId,
        utmParams: this.utmParamsForImage
      });
    },

    sendVotesRGForTest({ fieldType, value, goalName, id }) {
      const testTypeMap = {
        ['Опрос Тест']: 'Стандартный',
        ['Опрос Да-Нет']: 'Да-Нет',
        ['Опрос Обычный']: 'Опрос',
        ['Опрос С картинками']: 'Опрос с картинками'
      };
      this.sendNewReachGoal(fieldType, value, goalName);
      if (guardUnspecified(testTypeMap[fieldType])) {
        this.sendNewFormatReachGoal(
          'ClickTest',
          'Тест',
          'Клик',
          testTypeMap[fieldType],
          id
        );
      }
    },
    sendTestWithResultReachGoal(id) {
      let testNumber = 1;

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].type === 'test') {
          if (this.data[i].media.poll === id) {
            this.sendVotesRGForTest({
              fieldType: 'Опрос Тест',
              value: `Проголосовал №${testNumber}`,
              goalName: 'VotesDone',
              id: id.replace('test', '')
            });

            break;
          } else {
            testNumber++;
          }
        }
      }
    },
    sendViewRGForTest({ type, id }) {
      const testType = TEST_MAP[type];
      this.sendNewFormatReachGoal('ViewTest', 'Тест', 'Просмотр', testType, id);
    },
    sendViewRGForTestResult({ type }) {
      const testType = TEST_MAP[type];
      this.sendNewFormatReachGoal(
        'ViewTestResult',
        'Результаты теста',
        'Просмотр',
        `${testType}`
      );
    },
    getInreadAdvBlock(blockType) {
      const advBlockName = convertToCamelCase(blockType);

      const inreadAdvBlock = this.store.advModule[advBlockName];

      return inreadAdvBlock;
    },
    checkInfiniteInread(blockType) {
      return INFINITE_INREADS.includes(blockType);
    },
    isDisplayAdv(blockType) {
      return (
        guardUnspecified(blockType) &&
        blockType.includes('record_inread_advert') &&
        this.getInreadAdvBlock(blockType)
      );
    },
    createImageShareLink(imageId) {
      return this.store.sharingModule.getRecordImageShareLink(
        imageId,
        this.utmParamsForImage
      );
    },
    getAdvInImage(textBlock) {
      if (textBlock.media.hasAdv) {
        const advInImageBlock = this.store.advModule.advInImageBlock;
        return advInImageBlock || null;
      }
      return null;
    },
    initInImageAdvVOX() {
      if (this.isShowInImageAds && typeof window._tx === 'undefined') {
        this.store.commonModule.externalScriptsService.injectScriptToHead({
          src: VOX_SCRIPT_SRC
        });
        window._tx = window._tx || {};
        window._tx.cmds = window._tx.cmds || [];
        window._tx.cmds.push(function () {
          window._tx.init({
            zIndex: 90,
            onFailInImageLoad: e => {}
          });
        });

        window.addEventListener('scroll', this.onScrollContent);
      }
    },
    onScrollContent() {
      const displayAdvCount = document.querySelectorAll(
        '[data-hyb-ssp-ad-place-status="display"]'
      ).length;

      if (displayAdvCount > 0) {
        const productName = 'Реклама';
        const fieldType = 'Баннер на фото';
        const value = 'Просмотр';
        const goalName = 'InimageView';

        this.sendNewReachGoal(fieldType, value, goalName, productName);

        window.removeEventListener('scroll', this.onScrollContent);
      }
    },
    showRegisterModal() {
      this.isAuthModalRendered = true;
      this.isAuthModalOpen = true;
      this.modalType = 'register';
    },
    sendYoutubeViewedRG({ videoId, goalName }) {
      const blockType = 'Центральная колонка';
      const fieldType = 'ВидеоПлеер';
      const value = { [this.recordId]: { [videoId]: 0 } };
      const valueName = { ['Просмотр YouTube']: value };
      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName
      });
    },
    checkAllowInImageAdv(position) {
      return position <= 3;
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';

.contentBlocksList {
  position: relative;

  &:after {
    display: block;
    content: '';
    clear: both;
  }
}

.insertBlock {
  margin: $record-between-indent 0;
}

.mediaBlock {
  clear: both;
}
</style>
